import * as basicLightbox from "basiclightbox";
import $ from "jquery";
import { MpBookmark } from "../../common/bookmark.js";
import "bootstrap/js/dist/tooltip";
import { formAddCsrfProtection, getCsrfToken } from "../../common/utils.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// Tab bookmarks
	const followStaff = document.querySelector("#tab_follow_staff");
	if (followStaff) {
		new MpBookmark(followStaff, {
			message: followStaff.querySelector(".tab_label"),
			message_on: "Non seguire",
			message_off: "Segui",
		});
	}

	// Favorites page
	for (const el of document.querySelectorAll("._bookmark")) {
		new MpBookmark(document.querySelector(`#${el.id}`), {
			message: document.querySelector(`#${el.id} .tab_label`),
			message_on: "Non seguire",
			message_off: "Segui",
		});
	}

	// TOOLTIP BOOTSTRAP
	$(".btn-tooltip").tooltip();

	// COLLAPSE LISTA PAGINE PROFILO
	document.querySelector(".list-toggle").addEventListener("click", (event) => {
		document.querySelector(".list-mobile").classList.toggle("active");
	});

	// messages
	if (
		!!document.querySelector(".btn-private-message") &&
		document.querySelector(".btn-private-message").dataset.forbidden === "1"
	) {
		document
			.querySelector(".btn-private-message")
			.addEventListener("click", (e) => {
				document.querySelector("#cant_send_message").classList.remove("d-none");
				e.preventDefault();
			});
	}

	// blacklist
	for (const el of document.querySelectorAll(".block_unlock")) {
		el.addEventListener("click", (event) => {
			event.preventDefault();
			const target = event.currentTarget;
			getCsrfToken().then((token) => {
				if (token) {
					const formData = new FormData();
					formData.append("csrfmiddlewaretoken", token);
					fetch(target.href, {
						headers: {
							"X-Requested-With": "XMLHttpRequest",
						},
						method: "POST",
						body: formData,
					})
						.then((response) => response.text())
						.then((data) => {
							if (data === "Blocca utente") {
								target.querySelector(".unblock_icon").classList.add("d-none");
								target.querySelector(".block_icon").classList.remove("d-none");
							} else {
								target.querySelector(".block_icon").classList.add("d-none");
								target
									.querySelector(".unblock_icon")
									.classList.remove("d-none");
							}
							$(target).attr("data-original-title", data).tooltip("show");
						})
						.catch((error) => {
							console.warn(" --- Error: ", error);
						});
				}
			});
		});
	}

	// segnala
	const reportModal = document.querySelector("#_report-modal");
	if (reportModal) {
		reportModal.addEventListener("click", (e) => {
			const reportUserLightbox = basicLightbox.create(
				document.querySelector("#_report-modal-form").innerHTML,
				{
					onShow: (instance) => {
						const container = instance.element();
						container
							.querySelector("#_report-modal-close")
							.addEventListener("click", (e) => {
								instance.close();
							});
					},
				},
			);
			reportUserLightbox.show();
		});
	}

	// Upload cover artwork
	const artworkForm = document.querySelector("#_profile_artwork_form");
	if (artworkForm) {
		const image_input = artworkForm.querySelector("#id_image");
		const cover_actions = document.querySelector("._user_cover_actions");
		const cover_spin = document.querySelector("._user_cover_spinner");
		const profile_heading = document.querySelector("#_profile_heading");

		image_input.addEventListener("change", (event) => {
			const uploaded = image_input.files[0];
			if (typeof uploaded === "undefined") {
				return;
			}

			cover_actions.classList.add("d-none");
			cover_actions.classList.remove("d-flex");
			cover_spin.classList.add("d-flex");
			cover_spin.classList.remove("d-none");

			formAddCsrfProtection(artworkForm).then((data) => {
				const formData = new FormData(artworkForm);
				fetch(artworkForm.getAttribute("action"), {
					headers: {
						"X-Requested-With": "XMLHttpRequest",
					},
					method: "POST",
					body: formData,
				})
					.then((response) => response.json())
					.then((data) => {
						if (data.url) {
							setTimeout(() => {
								profile_heading.classList.remove("default_heading");
								profile_heading.style.backgroundImage = `url(${data.url})`;
								profile_heading.style.backgroundPosition = "center center";
								profile_heading.style.backgroundSize = "cover";
								cover_actions.classList.add("d-flex");
								cover_actions.classList.remove("d-none");
								cover_spin.classList.add("d-none");
								cover_spin.classList.remove("d-flex");
							}, 1000);
						} else {
							// mostra messaggio errore
							document.querySelector("#_profile_actions").insertAdjacentHTML(
								"afterbegin",
								`<div id="_profile_actions_messages" class="position-absolute p-4">
                <p class="message m-0">${data.errors}</p><p class="close_message text-right m-0">
                  <span class="bg-primary font-weight-bold text-uppercase px-2 py-1 text-white">chiudi</span>
                </p></div>`,
							);
							document
								.querySelector(".close_message")
								.addEventListener("click", (e) => {
									e.preventDefault();
									document
										.querySelector("#_profile_actions")
										.removeChild(
											document.querySelector("#_profile_actions_messages"),
										);
									cover_actions.classList.add("d-flex");
									cover_actions.classList.remove("d-none");
									cover_spin.classList.add("d-none");
									cover_spin.classList.remove("d-flex");
								});
						}
					})
					.catch((error) => {
						console.error("Error:", error);
					});
			});
		});

		document
			.querySelector("#_profile_upload_artwork")
			.addEventListener("click", (e) => {
				e.preventDefault();
				image_input.click();
			});

		document
			.querySelector("#_profile_upload_artwork_delete")
			.addEventListener("click", (e) => {
				e.preventDefault();
				if (profile_heading.classList.contains("default_heading")) {
					return false;
				}
				cover_actions.classList.add("d-none");
				cover_actions.classList.remove("d-flex");
				cover_spin.classList.add("d-flex");
				cover_spin.classList.remove("d-none");
				fetch(e.currentTarget.href, {
					headers: {
						"X-Requested-With": "XMLHttpRequest",
					},
				})
					.then((response) => response.text())
					.then((data) => {
						setTimeout(() => {
							profile_heading.removeAttribute("style");
							profile_heading.classList.add("default_heading");
							cover_actions.classList.add("d-flex");
							cover_actions.classList.remove("d-none");
							cover_spin.classList.add("d-none");
							cover_spin.classList.remove("d-flex");
						}, 1000);
					})
					.catch((error) => {
						console.warn(error);
					});
			});
	}
});
